"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raceAll = exports.raceAllPerformance = exports.delay = void 0;
function delay(t, val) {
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(val); }, t);
    });
}
exports.delay = delay;
function raceAllPerformance(promises, timeoutTime, timeoutVal) {
    return Promise.all(promises.map(function (p) {
        var startTime = performance.now();
        return Promise.race([
            p.then(function (value) { return ({
                value: value,
                elapsed: performance.now() - startTime,
            }); }),
            delay(timeoutTime, timeoutVal).then(function (value) { return ({
                value: value,
                elapsed: performance.now() - startTime,
            }); }),
        ]);
    }));
}
exports.raceAllPerformance = raceAllPerformance;
function raceAll(promises, timeoutTime, timeoutVal) {
    return Promise.all(promises.map(function (p) {
        return Promise.race([p, delay(timeoutTime, timeoutVal)]);
    }));
}
exports.raceAll = raceAll;
//# sourceMappingURL=raceAll.js.map